// extracted by mini-css-extract-plugin
export default {"tasks":"nM-z","task":"oM-z","svg":"pM-z","text":"qM-z"};